/**
 * Schedule timezone – Europe/Copenhagen (Danish time).
 * SMSWiser operates in Danish time; all schedule UI and API use this.
 * For Media Devoted | Created By Ciro Autiero
 */

import {
  APP_DISPLAY_TIMEZONE,
  formatInZone,
  getDatePartsInZone,
  isBeforeTodayInZone,
  utcIsoToZoneLocal,
  zoneLocalToUtcIso,
} from '@/lib/datetime-timezone';

export const SCHEDULE_TIMEZONE = APP_DISPLAY_TIMEZONE;

export const scheduleLocalToUtcIso = (s: string) => zoneLocalToUtcIso(s, SCHEDULE_TIMEZONE);
export const utcIsoToScheduleLocal = (s: string) => utcIsoToZoneLocal(s, SCHEDULE_TIMEZONE);
export const formatScheduleDateTime = (d: string | Date) =>
  formatInZone(typeof d === 'string' ? new Date(d) : d, SCHEDULE_TIMEZONE);

/**
 * True when the scheduled instant is before `nowUtc` (label is shown in {@link SCHEDULE_TIMEZONE}).
 * Comparison uses absolute time; same result as “past” in Copenhagen wall time for that instant.
 */
export function isScheduleExecuteAfterElapsed(executeAfterIso: string, nowUtc: Date = new Date()): boolean {
  const t = new Date(executeAfterIso.trim()).getTime();
  if (Number.isNaN(t)) return false;
  return t < nowUtc.getTime();
}

export const isBeforeScheduleToday = (d: Date) => isBeforeTodayInZone(d, SCHEDULE_TIMEZONE);
export const getDatePartsInScheduleZone = (d: Date) => getDatePartsInZone(d, SCHEDULE_TIMEZONE);
